import { NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import { NotifyUtils } from '@singularsystems/neo-core';
import { AccessControlTypes } from "../../AccessControlTypes";
import InviteUserCommand from '../../Models/Commands/UserCommands/InviteUserCommand';
import { TextConstants } from '../../../Common/TextConstants';

@NeoModel
export default class InviteUsersVM extends Views.ViewModelBase {

    public inviteUser: InviteUserCommand | null = null;

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private usersApiClient = AppService.get(AccessControlTypes.ApiClients.UsersApiClient),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {
        super(taskRunner);
    }

    public async initialise() {
        this.inviteUser = new InviteUserCommand();
        this.inviteUser.postRegisterRedirectURL = AppService.get(Types.Config).baseUrl;
    }

    public async submitUserInvite() {
        const inviteUserResponse = await this.taskRunner.run(async () => await this.usersApiClient.inviteUser(this.inviteUser!.toJSObject()));
        this.inviteUser = new InviteUserCommand();

        if (inviteUserResponse.data.success) {
            NotifyUtils.add("Invite Sent", "The invite will be sent to the e-mail address provided.",
                "success" as any, 10);
        } else {
            NotifyUtils.add(TextConstants.Titles.Error,
                inviteUserResponse.data.error !== "" ? inviteUserResponse.data.error :
                    "Failed to send the invite to the e-mail address provided.",
                "danger" as any, 10);
        }
    }
}